import { defineComponent as _defineComponent } from 'vue'
import { useSwapStore, useWalletStore } from "@/pinia";
import { ref } from "vue";
import TransactionHistory from "./TransactionHistory.vue";
import router from "@/router";

// store

export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionsHistory',
  setup(__props) {

const swapStore = useSwapStore();
const walletStore = useWalletStore();

// data
const opened = ref<boolean>(false);

// setup
router.afterEach((to, from) => {
	if (to.fullPath === from.fullPath) return;
	opened.value = false;
});

return { __sfc: true,swapStore, walletStore, opened, TransactionHistory }
}

})